import { render, staticRenderFns } from "./sub.vue?vue&type=template&id=72e327a7&"
import script from "./sub.vue?vue&type=script&lang=js&"
export * from "./sub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports